module.exports = __webpack_public_path__ + "50fd6bc4be51c20842b7e288ffe11f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11.jpg
// module id = wTDx
// module chunks = 0